import React from "react"
import PropTypes from "prop-types"

// Style
import styled from "styled-components"

const Button = styled.div`
  .button {
    &:hover {
      border-bottom: ${props => (props.primaryColor ? "3px solid " + props.primaryColor : "")};
    }
  }

  .isActive {
    border-bottom: ${props => (props.primaryColor ? "3px solid " + props.primaryColor : "")};
  }
`

const SwitchButton = ({ primaryActionColor, setSelectedPath, selectedPath, label1, label2 }) => (
  <Button id="choice_path_container" primaryColor={primaryActionColor}>
    <div
      onClick={() => setSelectedPath("franceDep")}
      className={`${selectedPath === "franceDep" ? "isActive" : "button"}`}
    >
      {label1}
    </div>
    <div
      onClick={() => setSelectedPath("franceRegNew")}
      className={`${selectedPath === "franceRegNew" ? "isActive" : "button"}`}
    >
      {label2}
    </div>
  </Button>
)

SwitchButton.propTypes = {
  setSelectedPath: PropTypes.func,
  selectedPath: PropTypes.string,
}

SwitchButton.defaultProps = {
  onZoomOut: () => {},
  selectedPath: "",
}

export default SwitchButton
